import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PartialBlindSvg = function PartialBlindSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m16.67 17.84 4.41 4.409.92-.92-4.182-4.182a10.22 10.22 0 0 0 3.677-4.661l.093-.237-.093-.237A10.19 10.19 0 0 0 12 5.528c-1.684 0-3.272.408-4.67 1.13L2.92 2.25l-.92.92L6.182 7.35a10.22 10.22 0 0 0-3.677 4.661l-.093.237.093.237A10.19 10.19 0 0 0 12 18.97c1.684 0 3.271-.408 4.67-1.13m-6.544-8.384L8.304 7.632a8.893 8.893 0 0 1 11.885 4.617 8.92 8.92 0 0 1-3.307 3.961l-2.087-2.087a3.365 3.365 0 0 0-4.667-4.667m3.718 3.717-2.767-2.767a2.065 2.065 0 0 1 2.767 2.767m-2.463 4.475a9 9 0 0 0 1.597-.032L5.271 9.91a9 9 0 0 0-.702.928zm-2.314-.474-5.154-5.153-.1.228a8.92 8.92 0 0 0 5.254 4.925M6.191 8.99l8.32 8.32q.614-.18 1.186-.443L7.118 8.288a9 9 0 0 0-.927.701",
    clipRule: "evenodd"
  }));
};
export var PartialBlind = function PartialBlind(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PartialBlindSvg
  }));
};